import React, {
    createContext,
    useState,
    useEffect,
    useCallback,
    useContext,
    useMemo,
} from 'react';
import { useMutation, useReactiveVar } from '@apollo/client';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import isEmpty from 'lodash/isEmpty';

import BILLING_MUTATION from 'app/graphql/network/billing';

import { getDigitsFromPhone } from 'app/utils/phone';

// import { currentPhoneVar, promocodeVar } from 'app/apollo/reaction';
import { FiltersContext } from './FiltersProvider';
import { BasketContext } from './BasketProvider';
import { ConfigContext } from './ConfigProvider';


export const BillingContext = createContext({
    updateBilling: () => { },
});


export default function BillingProvider(props) {
    const { children } = props;

    const {
        defaultPromocode,
        paymentMethod,
        pageId,
    } = useContext(ConfigContext);
    const { period } = useContext(FiltersContext);
    const {
        basket,
        refetchBasket,
    } = useContext(BasketContext);

    const [isBillingInitialized, setIsBillingInitialized] = useState(false);
    const [savedPromocode, setSavedPromocode] = useState(defaultPromocode);
    // const currentPromocode = useReactiveVar(promocodeVar);

    const [billingMutation] = useMutation(BILLING_MUTATION);

    const updateBilling = useCallback(async (vars) => {
        const {
            phone,
            promocode: promocodeVar,
            paymentMethod: paymentMethodVar,
        } = vars;

        const promocode = promocodeVar || savedPromocode;

        const { pathname, hash } = window.location;
        const query = queryString.parse(window.location.search);

        if (promocode) {
            query.promo_code = promocode;
        } else {
            delete query.promo_code;
        }

        if (!isEmpty(query)) {
            const nextQuery = queryString.stringify(query);
            window.history.replaceState('', '', `${pathname ?? ''}?${nextQuery}${hash ?? ''}`);
        } else {
            window.history.replaceState('', '', `${pathname ?? ''}${hash ?? ''}`);
        }

        setSavedPromocode(promocode);

        const variables = {
            payment_method: paymentMethodVar || paymentMethod || 'online',
            period,
            promocode: promocode || undefined,
        };

        if (phone) {
            variables.phone = getDigitsFromPhone(phone);
            const customEvent = new CustomEvent('changePhone', {
                bubbles: true,
                detail: {
                    phone,
                },
            });
            document.dispatchEvent(customEvent);
        }

        const mutationResponse = await billingMutation({ variables });

        await refetchBasket();

        return mutationResponse;
    }, [period, savedPromocode, setSavedPromocode, refetchBasket]);


    useEffect(() => {
        const promocodeFromUrl = queryString.parse(window.location.search).promo_code;
        const promocodeFromBasket = basket.discount_conditions.promocode;


        localStorage.removeItem('promocodeFromBasketToSet');
        const isExceptionForPromoPage = pageId === 'blyuda-dlya-novogodnego-stola' || pageId === 'mealprep';
        // if (isExceptionForPromoPage && promocodeFromBasket) {
        //     localStorage.setItem('promocodeFromBasketToSet', promocodeFromBasket);
        // }

        // const promocodeFromBasketToSet = localStorage.getItem('promocodeFromBasketToSet');

        const variables = {
            phone: '',
            promocode: promocodeFromUrl || promocodeFromBasket,
        };

        updateBilling(variables).then(() => {
            setIsBillingInitialized(true);
        });

        // didMount
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const contextValue = useMemo(() => ({
        updateBilling,
        billingState: {
            promocode: savedPromocode,
        },
    }), [updateBilling, savedPromocode]);

    if (!isBillingInitialized) return null;

    return (
        <BillingContext.Provider value={contextValue}>
            {children}
        </BillingContext.Provider>
    );
}


BillingProvider.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]).isRequired,
};
